const IST = 'Asia/Kolkata';

/**
 * "Last refreshed: HH:MM (GMT +5:30)" (24-hour) from the API's `as_of` timestamp.
 * A timestamp with an offset is converted to IST; one without is already IST wall-clock time, so it is read as is.
 * Returns null when there is no usable timestamp.
 */
export function formatLastRefreshed(asOf: string | null | undefined): string | null {
  if (!asOf) return null;
  let hhmm: string | null = null;
  if (/(Z|[+-]\d{2}:?\d{2})$/.test(asOf)) {
    const d = new Date(asOf);
    if (!Number.isNaN(d.getTime())) {
      hhmm = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: IST }).format(d);
    }
  } else {
    hhmm = /[T ](\d{2}:\d{2})/.exec(asOf)?.[1] ?? null;
  }
  return hhmm ? `Last refreshed: ${hhmm} (GMT +5:30)` : null;
}
